import GameObject from './GameObject';
import gameConsts from './gameConsts';

const INCREASE_SPEED = 0.5;
const DEFAULT_BORDER = 26;
const LANES = 3;
const BORDERS = 2;

export default class Road extends GameObject {
  constructor({ game, values }) {
    super({
      game,
      values,
      name: 'road',
    });
    this.item = this._game.add.tileSprite(this._coordX, 0, this._defaultWidth, gameConsts.GAME_HEIGHT, 'nfs', `${this._name}.png`);
    this.defaultSpeed = values.speedY;
  }
  get bounds() {
    return this.item.getBounds();
  }
  get stop() {
    return Math.round(this._playerData.speedY) <= 0;
  }
  get speed() {
    return this._playerData.speedY;
  }
  get part() {
    return (this.width - (BORDERS * this.borderWidth)) / LANES;
  }
  get borderWidth() {
    return DEFAULT_BORDER * this._scaleValue;
  }
  get _coordX() {
    return (gameConsts.GAME_WIDTH / 2) - (this.width / 2);
  }
  scaleItem() {
    this.item.scale.x = this._scaleValue;
    this.item.position.x = this._coordX;
  }
  update() {
    this.item.tilePosition.y += this._playerData.speedY;
  }
  speedDown() {
    this._playerData.speedY = (98 * this._playerData.speedY) / 100;
  }
  speedUp() {
    this._playerData.speedY = this.defaultSpeed;
  }
  increaseSpeed() {
    this.defaultSpeed += INCREASE_SPEED;
  }
}



// WEBPACK FOOTER //
// ./src/js/Road.js